import SideTool from '@/global/components/side-tool'
import './index.less'
import { useLocation, useParams } from 'react-router-dom';
import { MonitorObject } from '@/global/interface/monitor-object/monitor-object';
import { useEffect, useState } from 'react';
import TnMessage from '@/global/components/message';
import { getMonitorObjectWithParamDqsByProjectId } from '@/api/monitor-object/monitor-object';
import MonitorObjectWithParamsItem from './monitor-object-item/item';

/**
 * 传感器匹配
 */
export default function ParamMatchSensor() {
    const location = useLocation(); // 路由
    const { projectId } = useParams();// 路由参数，项目id
    const [list, setList] = useState<MonitorObject[]>([]); // 监测对象列表
    const [activeItemId, setActiveItemId] = useState<number>(); // 激活的监测对象
    const [activeParamId, setActiveParamId] = useState<number>(); // 激活的监测参数

    
    // 监听路由，高亮左侧列表
    useEffect(() => {
        let pathName = location.pathname;

        const match = pathName.match(/\/bim\/project\/\d+\/monitor-object\/(\d+)/);
        if (match) {
            const id = match[1];
            setActiveItemId(+id);
        } else {
            setActiveItemId(null);
        }
        const matchParam = pathName.match(/\/bim\/project\/\d+\/monitor-parameter\/(\d+)/);
        if (matchParam) {
            const id = matchParam[1];
            setActiveParamId(+id);
        } else {
            setActiveParamId(null);
        }
    }, [location.pathname])

    useEffect(() => {
        if (!projectId) return;
        generateData();
    }, [projectId]) // 项目id变化时，获得监测对象列表

    // 根据项目id获得监测对象列表，含根监测参数和直接参数
    const generateData = () => {
        getMonitorObjectWithParamDqsByProjectId(+projectId).then(res => {
            let list: MonitorObject[] = res.data || [];
            setList(list);
        }).catch(err => {
            if (err.data) {
                TnMessage.error(err.data);
            } else {
                TnMessage.error("获得数据失败")
            }
        })
    }

    return (
        <div className="param-match-sensor-side-container">
            <SideTool />
            <div className="list-main">
                {list.map((item, index) => (
                    <MonitorObjectWithParamsItem key={index} monitorObject={item} active={activeItemId == item.id} activedParamId={activeParamId} />
                ))}
            </div>
        </div>
    )
}